module.exports = __webpack_public_path__ + "static/media/in-love-emoji-svgrepo-com.35cb7cb8.svg";